const types = {
   LOADING: 'LOADING',
   SEND_PROMPT_MODE1: 'SEND_PROMPT_MODE1',
   SEND_PROMPT_MODE0: 'SEND_PROMPT_MODE0',
   RECEIVE_COMPLETION: 'RECEIVE_COMPLETION',
   RECEIVE_IMAGE: 'RECEIVE_IMAGE',

   CLEAR_MODE1: 'CLEAR_MODE1',
   CLEAR_MODE0: 'CLEAR_MODE0',
}

export default types
